import RejectionModal from './RejectionModal';

export default RejectionModal;
